import { MouseEvent } from "react";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import {
  selectState,
  getEmployees,
  setSelectedIndex,
  setSort
} from "../employeeSlice";
import { useSelector } from "react-redux";
import DeleteEmployeeModal from "./DeleteEmployeeModal";
import { setDeleteEmployeeModalOpen } from "../employeeSlice";
import { SalaryType } from "Dashboard/scenes/HumanResources/domain/SalaryType";
import { StatusType } from "Dashboard/scenes/HumanResources/domain/StatusType";
import Loader from "components/Loader/Loader";
import { FormatDateShort } from "utils/dateUtils";
import { GenderType } from "Dashboard/scenes/HumanResources/domain/GenderType";
import DeleteIcon from "./../../../../../images/delete-icon.png";
import StarIcon from "./../../../../../images/star.png";
import InfoTooltip from "components/Popup/InfoTooltip";
import { hasFullAccessTo } from "utils/authUtil";
import { selectState as selectStateAuth }
  from "authentication/main.slice";
import { HUMAN_RESOURCES_MODULE_NAME }
  from "Dashboard/scenes/HumanResources/domain/HumanResourcesModule";

const TopSection = () => {
  const dispatch = useAppDispatch();
  const { list, selectedIndex, loading, getEmployeesParams }
    = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);

  useEffect(() => {
    dispatch(getEmployees(getEmployeesParams));
  }, [dispatch, getEmployeesParams]);

  const setSelected = (index: number) => (e: MouseEvent<HTMLDivElement>) => {
    dispatch(setSelectedIndex(index));
    e.preventDefault();
  };

  const handleSort = (
    sortKey: string, typeOfValue: 'string' | 'boolean' | 'date'
  ) => {
    dispatch(setSort({ key: sortKey, typeOfValue: typeOfValue }));
  };

  return (
    <section className="loading-container">
      {loading && <Loader />}
      <div className="g-grid g-header">
        <div className="row">
          <div className="col lowercase center separator-line text-medium">ser</div>
          <div className="col lowercase center separator-line text-medium clickable"
            onClick={() => handleSort("employeeName", "string")}>ime
          </div>
          <div className="col lowercase center separator-line text-medium">pol</div>
          <div className="col lowercase center separator-line text-medium">radno mesto</div>
          <div className="col lowercase center separator-line text-medium">prijavljen</div>
          <div className="col lowercase center separator-line text-medium">do</div>
          <div className="col lowercase center separator-line text-medium">
            nije na karnete
          </div>
          <div className="col lowercase center separator-line text-medium">status</div>
          <div className="col lowercase center text-medium"></div>
        </div>
      </div>

      <div className="g-grid g-content">
        {list &&
          list.map((item, index) => (
            <div
              className={`row ${selectedIndex === index ? " active" : ""}`}
              key={index}
              onClick={setSelected(index)}
            >
              <div className="col center light">
                <div className="bg-item center">{item.employeeId}</div>
              </div>

              <div className="col">
                <div className="bg-item">
                  <span className={`strong l-font${item.status === StatusType.ACTIVE ? "" : " light"}`}>{item.employeeName}</span>
                  {item.hasAlarm &&
                    <img className="star" src={StarIcon} alt="" />}
                </div>
              </div>

              <div className="col text-medium">
                <div className="bg-item center">
                  <span className="light">
                    {item.gender === GenderType.MALE ? "M" : "Ž"}
                  </span>
                </div>
              </div>

              <div className="col center text-medium">
                <div className="bg-item right transparent-bg-item">
                  <span className="light">{item.employeeRole.roleName}</span>
                </div>
              </div>

              <div className="col center">
                <input type="checkbox" checked={item.registered} readOnly />
              </div>

              <div className="col center">
                <div className="bg-item center">
                  <span className="light">
                    {item.employedUntil
                      ? FormatDateShort(item.employedUntil)
                      : ""}
                  </span>
                </div>
              </div>

              <div className="col center">
                <button>
                  <input
                    type="checkbox"
                    checked={item.salaryType === SalaryType.MONTHLY}
                    readOnly
                  />
                </button>
              </div>

              <div className="col center text-medium">
                <div className="bg-item center">
                  <span className="light">
                    {item.status === StatusType.ACTIVE
                      ? "Aktivan"
                      : "Neaktivan"}
                  </span>
                </div>
              </div>

              {false && hasFullAccessTo(user, HUMAN_RESOURCES_MODULE_NAME)
                ? (
                  <InfoTooltip tooltip="Obriši zapis" classesProp="col delete-icon-div center">
                    <button
                      onClick={(e: MouseEvent) => {
                        e.stopPropagation();
                        dispatch(
                          setDeleteEmployeeModalOpen({
                            visible: true,
                            index: index,
                          })
                        );
                      }}
                    >
                      <img className="delete-icon" src={DeleteIcon} alt="" />
                    </button>
                  </InfoTooltip>
                )
                : (<></>)}
            </div>
          ))}
      </div>

      <div className="g-grid g-footer">
        <div className="row row-count">
          <div className="col"></div>
          {/* <div className="col strong">
            <div className="bg-item">{list.length}</div>
          </div> */}
          <div className="col"></div>
          <div className="col"></div>
          <div className="col"></div>
          <div className="col"></div>
          <div className="col strong right text-medium text-footer">ukupno</div>
          <div className="col strong">
            <div className="bg-item center">{list.length}</div>
          </div>
        </div>
      </div>
      <DeleteEmployeeModal />
    </section>
  );
};

export default TopSection;
